// Singleton Socket.io client. Reuses one connection across the whole app so
// reconnection state is consistent and events aren't double-bound.
//
// Sprint 11b — multi-server: when the active server changes, the old socket
// is torn down and a new one is created pointing at the new baseUrl.

import { io, Socket } from 'socket.io-client';
import { getActiveBaseUrl } from '../stores/servers.store';

let socket: Socket | null = null;
let socketBaseUrl: string | null = null;

function createSocket(baseUrl: string): Socket {
  const opts: Parameters<typeof io>[1] = {
    withCredentials: true,
    reconnection: true,
    reconnectionDelay: 500,
    reconnectionDelayMax: 60_000,
    randomizationFactor: 0,
    reconnectionAttempts: Infinity,
    autoConnect: true,
    transports: ['websocket', 'polling'],
  };
  // When baseUrl is empty (same-origin), Socket.io auto-detects. When set,
  // we pass the explicit URL so the client connects cross-origin.
  if (baseUrl) {
    return io(baseUrl, opts);
  }
  return io(opts);
}

export function getSocket(): Socket {
  const base = getActiveBaseUrl();
  // If the target server changed, tear down the old socket and rebuild.
  if (socket && socketBaseUrl !== base) {
    socket.removeAllListeners();
    socket.disconnect();
    socket = null;
  }
  if (!socket) {
    socket = createSocket(base);
    socketBaseUrl = base;
  }
  return socket;
}
